import React from 'react';
import {Route} from 'react-router-dom';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';
import AsyncPage from './async';

export default (
  <Route key="/consumer/features/remove-people-from-photo" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/remove-people-from-photo" element={<AsyncPage />} />
  </Route>
);